import * as Sentry from '@sentry/react';

const dsn = process.env.SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    release: process.env.APP_VERSION,
  });
}

interface SentryUser {
  id?: string | number;
  email?: string;
  username?: string;
}

export function captureException(
  exception: unknown,
  extra?: Record<string, unknown>,
  level?: Sentry.SeverityLevel,
) {
  if (!dsn) return;

  Sentry.captureException(exception, { extra, level });
}

export function setUser(user: SentryUser | null) {
  if (!dsn) return;

  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id != null ? String(user.id) : undefined,
    email: user.email,
    username: user.username,
  });
}

export function setContext(name: string, context: Record<string, unknown> | null) {
  if (!dsn) return;

  Sentry.setContext(name, context);
}
